// extracted by css-extract-rspack-plugin
export default {"tableContainer":"LWXQc","table":"bVRzN","tableHead":"GFHHA"};